// src/mocks/data/creditNotes.demo.js

// Component reads: response.success → response.data.creditNotes / .pagination / .summary
export const creditNoteList = {
    success: true,
    data: {
        creditNotes: [
            // NC B — AFIP approved, linked to FERNANDEZ HERNAN factura (6505) — full cancellation → $12,143.48
            {
                id: 231,
                original_invoice_id: 6505,
                invoice_numero_comprobante: '00005-00003322',
                cae: '86151200123456',
                numero_comprobante: '00005-00000090',
                tipo_comprobante: 'NOTA DE CREDITO B',
                cancellation_type: 'full',
                fecha_emision: '2026-01-11',
                total: 12143.48,
                subtotal: null,
                cliente_razon_social: 'FERNANDEZ HERNAN',
                cliente_documento_nro: null,
                cliente_condicion_iva: null,
                status: 'approved',
                created_at: '2026-01-11T14:30:00.000000',
            },
            // NC B — AFIP approved, linked to DISTRIBUIDORA COSTANERA (6504) — partial → $12,236.52
            {
                id: 230,
                original_invoice_id: 6504,
                invoice_numero_comprobante: '00005-00003321',
                cae: '86151200123457',
                numero_comprobante: '00005-00000089',
                tipo_comprobante: 'NOTA DE CREDITO B',
                cancellation_type: 'partial',
                fecha_emision: '2026-01-10',
                total: 12236.52,
                subtotal: null,
                cliente_razon_social: 'DISTRIBUIDORA COSTANERA',
                cliente_documento_nro: null,
                cliente_condicion_iva: null,
                status: 'approved',
                created_at: '2026-01-10T11:20:00.000000',
            },
            // NC X (internal, no AFIP) — Consumidor Final — full cancellation of a presupuesto-origin invoice
            {
                id: 229,
                original_invoice_id: 6499,
                invoice_numero_comprobante: null,
                cae: null,
                numero_comprobante: null,
                tipo_comprobante: 'NOTA DE CREDITO C',
                cancellation_type: 'full',
                fecha_emision: '2026-01-08',
                total: 28500.00,
                subtotal: null,
                cliente_razon_social: 'Consumidor Final',
                cliente_documento_nro: null,
                cliente_condicion_iva: null,
                status: 'approved',
                created_at: '2026-01-08T09:15:00.000000',
            },
            // NC X (internal, no AFIP) — ROMERO GUSTAVO ANDRES — full cancellation
            {
                id: 228,
                original_invoice_id: 6486,
                invoice_numero_comprobante: null,
                cae: null,
                numero_comprobante: null,
                tipo_comprobante: 'NOTA DE CREDITO C',
                cancellation_type: 'full',
                fecha_emision: '2026-01-05',
                total: 20000.00,
                subtotal: null,
                cliente_razon_social: 'ROMERO GUSTAVO ANDRES',
                cliente_documento_nro: null,
                cliente_condicion_iva: null,
                status: 'approved',
                created_at: '2026-01-05T16:40:00.000000',
            },
        ],
        pagination: { page: 1, limit: 20, total: 4 },
        summary: {
            totalCount: 4,
            countByType:             { notaA: 0, notaB: 2, notaC: 2 },
            countByCancellationType: { full: 3, partial: 1 },
            currentMonth: { totalSum: 72880.00, count: 4 },
        },
    },
};

export const creditNoteDetail = {
    success: true,
    creditNote: {
        id: 231,
        original_invoice_id: 6505,
        invoice_numero_comprobante: '00005-00003322',
        cae: '86151200123456',
        numero_comprobante: '00005-00000090',
        tipo_comprobante: 'NOTA DE CREDITO B',
        cancellation_type: 'full',
        fecha_emision: '2026-01-11',
        total: 12143.48,
        subtotal: null,
        cliente_razon_social: 'FERNANDEZ HERNAN',
        status: 'approved',
        items: [],
    },
};

export const creditableItems = {
    success: true,
    items: [],
};

export const canCreditResult = {
    success: true,
    can_credit: true,
    reason: null,
};
